import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../data-services/index';
import { IHelp, HelpApiService } from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-contact-ebb',
    templateUrl: './contact-ebb.component.html',
    styles: [],
    standalone: false
})
export class ContactEbbComponent implements OnInit {
  public userEmailAddr = '';
  public userName = '';

  public listHelp: IHelp[] = [];
  public textContactEbbHelpfulTips: string;

  constructor(
    private readonly apiUser: AuthenticationService,
    private readonly apiHelp: HelpApiService
  ) { }

  ngOnInit() {
    this.loadHelpText();
    this.initializeEmailForm();
  }

  private loadHelpText(): void {
    this.apiHelp.setCurrentHelpTopicValue('Construction');
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          const indexContactEbbHelpfulTips = this.listHelp.findIndex(i => i.name.toLowerCase() === 'contactebbhelpfultips');
          this.textContactEbbHelpfulTips = this.listHelp[indexContactEbbHelpfulTips].answer;
        },
        error => console.log(error)
      );
  }

  private initializeEmailForm(): void {
    this.userEmailAddr = this.apiUser.currentUserValue.email;
    this.userName = this.apiUser.currentUserValue.fullName;
  }

}
